var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { _transformCurrency } from '@freelancer/datastore/currencies';
import { transformUserStatus } from '@freelancer/datastore/users/users.transformers';
import { getDate, getMonth, getYear } from 'date-fns';
// Transforms what the backend returns into a format your components can consume
// Should only be called in this collection's reducer (passed to `mergeDocuments`)
export function transformUsersSelf(user) {
    if (!user.primary_currency) {
        throw new ReferenceError('User without primary currency!');
    }
    return __assign(__assign({ id: user.id, username: user.username, firstName: user.first_name, lastName: user.last_name, publicName: user.public_name, displayName: user.display_name, primaryCurrency: _transformCurrency(user.primary_currency), address: user.address, dateOfBirth: user.date_of_birth, primaryLanguage: user.primary_language, hasLinkedEscrowComAccount: user.escrowcom_account_linked
            ? user.escrowcom_account_linked
            : false, email: user.email, status: user.status ? transformUserStatus(user.status) : undefined, marketingMobileNumber: user.marketing_mobile_number
            ? transformMarketingMobileNumber(user.marketing_mobile_number)
            : undefined }, getUsersSelfComputedFields(user.first_name, user.last_name, user.address, user.date_of_birth)), { enterpriseIds: user.enterprise_ids });
}
/**
 * These fields aren't returned by the backend but are computed from other
 * fields on `UsersSelf`
 */
export function getUsersSelfComputedFields(firstName, lastName, address, dob) {
    return {
        profileCompleted: !!firstName && !!lastName && !!address,
        escrowProfileCompleted: !!firstName &&
            !!lastName &&
            !!dob &&
            !!address &&
            !!address.address1 &&
            !!address.city &&
            !!address.state_code &&
            !!address.country &&
            !!address.zip,
    };
}
export function transformDOBToDMY(dob) {
    return {
        day: getDate(dob),
        month: getMonth(dob) + 1,
        year: getYear(dob),
    };
}
/** The format of fl-input uses for date is ISO String */
export function transformDMYToDOBString(dob) {
    var date = new Date(dob.year, dob.month - 1, dob.day);
    return date.toISOString();
}
export function transformMarketingMobileNumberAPIResult(marketingMobileNumberResult, original) {
    var marketingMobileNumber = {
        phoneNumber: marketingMobileNumberResult.marketing_mobile_number.phone_number,
        countryCode: marketingMobileNumberResult.marketing_mobile_number.country_code,
        status: marketingMobileNumberResult.marketing_mobile_number.status,
    };
    return __assign(__assign({}, original), { marketingMobileNumber: marketingMobileNumber });
}
export function transformMarketingMobileNumber(marketingMobileNumber) {
    return {
        phoneNumber: marketingMobileNumber.phone_number,
        countryCode: marketingMobileNumber.country_code,
        status: marketingMobileNumber.status,
    };
}
